import React from "react";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";
import TheUserImg from "../images/thimg.png";
import { FaStar, FaRegStar } from "react-icons/fa";
import Icon1 from "../images/theraicon1.svg";
import Icon2 from "../images/theraicon2.svg";
import Icon3 from "../images/theraicon3.svg";
import Icon4 from "../images/dollar.svg";
import Icon5 from "../images/clock.svg";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";

const AppointmentDetail = () => {
  return (
    <>
      <BannerSection
        banner={Banner}
        name={"Home"}
        title={"Appointment Detail"}
      />
      <section className="pt-5 detailsBox">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="flexUser">
                <div className="userDetails userDetails2">
                  <img src={TheUserImg} alt="" className="img-fluid thimg" />
                  <div className="rightflex">
                    <div className="d-flex align-items-center">
                      <img src={Icon1} alt="" className="img-fluid me-2 icc" />
                      <h2>
                        Sam Shelby{" "}
                        <span
                          className="online"
                          style={{ backgroundColor: "#4CD964" }}
                        ></span>
                      </h2>
                    </div>

                    <div className="d-flex align-items-center mb-3 mt-1">
                      <img src={Icon2} alt="" className="img-fluid me-2 icc" />
                      <h3 className="mb-0">Mental Health Therapy</h3>
                    </div>

                    <div className="d-flex align-items-center mb-3 mt-1">
                      <img src={Icon3} alt="" className="img-fluid me-2 icc" />
                      <p className="mb-0">17 June 2023 | 05:00 PM</p>
                    </div>

                    <div className="d-flex align-items-center mb-3 mt-1">
                      <img src={Icon4} alt="" className="img-fluid me-2 icc" />
                      <p className="mb-0">50 USD</p>
                    </div>

                    <div className="d-flex align-items-center mt-1">
                      <img src={Icon5} alt="" className="img-fluid me-2 icc" />
                      <p className="mb-0">1 hr</p>
                    </div>
                  </div>
                </div>
                <div className="text-center">
                  <Button
                    as={Link}
                    to="/bookanappointment"
                    className="btn btn-primary"
                  >
                    Book Again
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 specbox">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="mb-3">Your Feedback</h2>
              <div className="stardet">
                <FaStar />
                <FaStar />
                <FaStar />
                <FaStar />
                <FaRegStar />
                <span>4.5</span>
              </div>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquet
                arcu id tincidunt telluselit. Aliquet arcu id tincidunt tellus
                Lorem ipsum dolor Lorem ipsum dolor sit amet, consectetur
                adipiscing elit. Aliquet arcu id tincidunt telluselit. Aliquet
                arcu id tincidunt tellus Lorem ipsum dolor Lorem ipsum dolor sit
                amet, consectetur adipiscing elit. Aliquet arcu id tincidunt
                telluselit. Aliquet arcu id tincidunt tellus Lorem ipsum dolor
              </p>

              <h2 className="mb-3">Write Your Review</h2>
              <div className="stardet">
                <Link>
                  <FaStar />
                </Link>
                <Link>
                  <FaStar />
                </Link>
                <Link>
                  <FaStar />
                </Link>
                <Link>
                  <FaStar />
                </Link>
                <Link>
                  <FaRegStar />
                </Link>
              </div>
              <Form.Control
                placeholder="Write Your Review"
                as="textarea"
                rows={3}
                className="mt-4"
              />
              <Button className="btn btn-primary me-3">Submit</Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AppointmentDetail;
